export const formatDocument = {
    pdf: 0,
    word: 1
}